export const GSC_ONBOARDING_INTEGRATIONS_VISITED_STORAGE_KEY = 'gscOnboarding.integrationsVisited' as const;
